import React, { createContext, useContext, useState } from "react";

const EN = {
  nav_projects: "Projects", nav_manifesto: "Manifesto", nav_departments: "Departments", nav_news: "News", nav_admin: "Admin",
  submit_cta: "Submit Project",
  hero_overline: "Keimyung University · AI Projects & Innovation",
  hero_line1: "WHERE KNOWLEDGE", hero_meets: "meets", hero_line2: "BOUNDLESS", hero_line3: "CREATIVITY.",
  hero_brand1: "KEIMYUNG UNIVERSITY", hero_brand2: "AI PROJECTS",
  hero_tag: "Built at Keimyung, shared with the world.",
  hero_tag_ko: "계명대 구성원 모두의 프로젝트와 연구 성과를 캠퍼스와 세상에 공유합니다.",
  hero_subtitle: "Discover the research, inventions, and creative work of the entire Keimyung University community — students, faculty, and researchers — from autonomous drones over Daegu to generative hanbok couture.",
  hero_cta1: "Explore Projects", hero_cta2: "Submit Your Project",
  nav_home: "Showcase",
  nav_login: "Login", nav_logout: "Logout",
  auth_login_tab: "Sign In", auth_signup_tab: "Sign Up", auth_name: "Full Name", auth_sid: "University ID",
  auth_email: "Email", auth_dept: "Department", auth_level: "Affiliation", auth_ug: "Undergraduate", auth_g: "Graduate", auth_faculty: "Faculty", auth_staff: "Staff", auth_portal: "Member Portal",
  auth_pw: "Password", auth_create: "Create Account & Sign In", auth_creating: "Creating account…",
  auth_need: "A Keimyung member account is required to submit projects.",
  auth_submitting_as: "Submitting as",
  auth_forgot: "Forgot password?", auth_forgot_title: "Reset your password",
  auth_forgot_sub: "Enter your account email — we'll send you a reset link.",
  auth_forgot_btn: "Send Reset Link", auth_forgot_sent: "If that email is registered, a reset link is on its way.",
  auth_back_login: "Back to sign in",
  reset_title: "Choose a new password", reset_new: "New password (min 6 chars)", reset_confirm: "Confirm new password",
  reset_btn: "Update Password", reset_done: "Password updated — sign in with your new password.",
  reset_mismatch: "Passwords do not match", reset_invalid: "This reset link is invalid or expired. Please request a new one.",
  stat_users: "Registered Members", stat_rating: "Avg Rating",
  hero_spot_tag: "Live from the labs",
  hero_spot_quote: "SignBridge took first place at the Global AI Hackathon — 214 universities.",
  hero_spot_link: "Explore the project",
  metric_projects: "AI Projects", metric_depts: "Departments", metric_patents: "Patents Filed", metric_funding: "Research Funding",
  feat_overline: "Featured Capstones", feat_title_a: "This season's", feat_title_b: "spotlight", feat_view_all: "Full gallery",
  mani_overline: "The Keimyung Manifesto",
  mani_title_a: "Four commitments behind every", mani_title_b: "university project", mani_title_c: "you will find here.",
  dept_overline: "Colleges & Schools", dept_title_a: "Where the work", dept_title_b: "begins", dept_view_all: "Browse all projects",
  dept_showcased: "showcased", dept_project: "project", dept_projects: "projects",
  news_overline: "News & Events", news_title_a: "From the", news_title_b: "campus wire",
  gallery_overline: "The Gallery", gallery_title_a: "AI", gallery_title_b: "Projects",
  gallery_subtitle: "Every entry below is faculty-approved work from Keimyung University studios and laboratories.",
  gallery_search: "Search projects, ideas, technologies…", gallery_all_depts: "All departments", gallery_all: "All",
  gallery_loading: "Loading gallery…", gallery_empty_a: "Nothing matches that search yet.", gallery_empty_b: "Try a different keyword — or submit the project yourself.",
  sub_title: "Submit Your Project", sub_subtitle: "Reviewed by faculty before appearing in the public gallery.",
  sub_step: "Step", sub_of: "of",
  sub_f_title: "Project Title", sub_f_title_ph: "e.g. AURA — Autonomous Drone Navigation",
  sub_f_tagline: "Tagline", sub_f_tagline_ph: "One sentence that captures the idea",
  sub_f_dept: "Department", sub_f_dept_ph: "Select department", sub_f_cat: "Category", sub_f_cat_ph: "Select category",
  sub_f_other: "Other (type below)", sub_f_other_ph: "Type your department or subject", sub_f_other_cat_ph: "Type your category or field",
  sub_f_desc: "Full Description", sub_f_desc_ph: "What does it do? Who does it help? What was measured or achieved?",
  sub_f_team: "Team Members (comma separated)", sub_f_team_ph: "Jihun Park, Soyeon Lim",
  sub_f_emails: "Team Emails (optional, comma separated, same order)", sub_f_emails_ph: "jihun@kmu.ac.kr, soyeon@kmu.ac.kr",
  sub_f_video: "YouTube Demo URL (optional)",
  sub_f_tech: "Tech Stack (comma separated)", sub_f_tech_ph: "PyTorch, ROS 2, React",
  sub_f_demo: "Demo URL (optional)", sub_f_github: "GitHub URL (optional)", sub_f_award: "Award / Recognition (optional)", sub_f_award_ph: "e.g. 1st Place — University Hackathon 2026", sub_f_image: "Project Image",
  sub_f_upload: "Upload cover image (PNG / JPG)", sub_f_imgurl_ph: "…or paste an image URL",
  sub_next: "Continue", sub_back: "Back", sub_submit: "Submit for Review", sub_submitting: "Submitting…",
  sub_closed: "Submissions are currently closed", sub_closed_body: "The faculty team has paused new submissions. Please check back soon.",
  sub_success: "Project submitted for faculty review", sub_success_desc: "It will appear in the gallery once approved by an administrator.",
  login_tag: "Keimyung University", login_title: "Admin Portal", login_sub: "Faculty moderation & analytics access.",
  login_id_ph: "Admin ID", login_pw_ph: "Password", login_btn: "Sign In", login_busy: "Signing in…", login_welcome: "Welcome back, Administrator",
  admin_tag: "Faculty Console", admin_title: "Moderation & Analytics", admin_signout: "Sign out",
  stat_views: "Total Views", stat_likes: "Total Likes", stat_approved: "Approved", stat_pending: "Awaiting Review",
  chart_title: "Views by department (approved projects)",
  tab_pending: "Pending", tab_approved: "Approved", tab_rejected: "Rejected", tab_all: "All",
  act_approve: "Approve", act_reject: "Reject", act_feature: "Feature", act_featured: "Featured", act_delete: "Delete",
  feedback_ph: "Feedback for the project team…", act_confirm: "Confirm", queue_empty: "No projects in this queue.",
  news_mgr: "News & Events Manager", news_new: "Publish News Item", news_edit: "Edit Item",
  news_f_title: "Headline", news_f_excerpt: "Summary", news_f_tag: "Tag (Event / Research / …)", news_f_date: "Date", news_f_img: "Image URL",
  news_publish: "Publish", news_update: "Save Changes", news_cancel: "Cancel", news_delete: "Delete", news_edit_btn: "Edit", news_empty: "No news items yet.",
  feat_toggles: "Site Features", feat_toggles_sub: "Turn homepage sections and public features on or off.",
  toggle_news: "News & Events section", toggle_marquee: "Editorial marquee", toggle_manifesto: "Manifesto chapters",
  toggle_departments: "Departments showcase", toggle_submissions: "Public project submissions",
  creds_title: "Admin Credentials", creds_sub: "Change your sign-in ID and password. Current password required.",
  creds_current: "Current password", creds_new_id: "New admin ID (optional)", creds_new_pw: "New password (optional, min 8 chars)",
  creds_save: "Update Credentials", creds_saving: "Updating…",
  footer_tagline: "The official AI projects showcase of Keimyung University — where students, faculty, and staff turn research, creativity, and technology into real-world impact.",
  footer_platform: "Platform", footer_campus: "Campus", footer_gallery: "Projects Gallery", footer_manifesto: "Manifesto",
  footer_departments: "Departments", footer_admin: "Admin Portal", footer_rights: "© 2026 Keimyung University · AI Projects Showcase", footer_contact: "Questions or feedback? Reach out:",
  footer_top: "Back to top",
  views_label: "views", like_toast: "Appreciation sent to the team", like_fail: "Could not register like",
  demo_link: "Live Demo", team_label: "Team", tech_label: "Tech Stack", video_label: "Demo Video",
  mkt_search: "Search projects (e.g. drones, AI, hanbok)", mkt_sort_popular: "Sort: Most popular", mkt_sort_latest: "Sort: Latest",
  mkt_all: "All", mkt_top: "Trending Now", mkt_stats: "Showcase Analytics",
  stat_total: "Showcased Projects", stat_views: "Total Views", stat_likes: "Total Likes", stat_depts: "Active Departments",
  mkt_more: "Browse all projects", mkt_details: "Details", mkt_run: "Demo", mkt_by: "by",
  mkt_login_details: "Sign in to view project details and demos", like_login: "Sign in to like projects",
  val1_t: "Built by Our Community", val1_b: "Capstones, bootcamp and research-lab outcomes",
  val2_t: "Faculty Reviewed", val2_b: "Every project passes moderation before listing",
  val3_t: "Published to Campus", val3_b: "Approved work is showcased for everyone",
  val4_t: "Growing Together", val4_b: "Community feedback shapes better projects",
  nav_overview: "Overview", nav_projects_adm: "Projects", nav_trash: "Trash", nav_news_adm: "News", nav_features: "Features", nav_creds: "Credentials",
  trash_empty: "Trash is empty. Deleted projects will appear here.",
  act_restore: "Restore", act_delete_forever: "Delete Forever", act_sure: "Sure?",
  top_title: "Top Projects by Views", overview_sub: "Platform performance at a glance",
  adm_submitted_by: "Submitted by", adm_links: "Links", adm_edit_project: "Edit Project",
  nav_my_projects: "My Projects", my_title: "My Submissions",
  my_sub: "Track the faculty review status of everything you have submitted.",
  my_empty: "You haven't submitted any projects yet.", my_submitted: "Submitted",
  my_feedback: "Faculty feedback", my_view_gallery: "Live in gallery",
  my_projects_tab: "Submissions", my_account_tab: "Account",
  my_withdraw: "Withdraw", my_edits_pending: "Edits awaiting review",
  my_edit_staged_note: "Your published project stays live — these edits will appear after faculty approval.",
  my_edit_resubmit_note: "Saving will resubmit your project for faculty review.",
  acct_new_pw: "New password (optional, min 6 chars)", acct_updated: "Account updated",
  adm_edits_pending: "Edits pending", adm_pending_edit_title: "Proposed changes from the submitter",
  adm_approve_edit: "Approve Changes", adm_discard_edit: "Discard",
};

const KO = {
  nav_projects: "프로젝트", nav_manifesto: "선언문", nav_departments: "단과대학", nav_news: "소식", nav_admin: "관리자",
  submit_cta: "프로젝트 제출",
  hero_overline: "계명대학교 · AI 프로젝트 & 이노베이션",
  hero_line1: "지식이", hero_meets: "만나는 곳,", hero_line2: "경계 없는", hero_line3: "창의성.",
  hero_subtitle: "대구 상공의 자율주행 드론부터 생성형 한복 큐튀르까지 — 학생, 교수, 연구원 등 계명대학교 구성원 모두의 연구, 발명, 창작을 만나보세요.",
  hero_brand1: "KEIMYUNG UNIVERSITY", hero_brand2: "AI PROJECTS",
  hero_tag: "Built at Keimyung, shared with the world.",
  hero_tag_ko: "계명대 구성원 모두의 프로젝트와 연구 성과를 캠퍼스와 세상에 공유합니다.",
  hero_cta1: "프로젝트 둘러보기", hero_cta2: "프로젝트 등록하기",
  nav_home: "쇼케이스",
  nav_login: "로그인", nav_logout: "로그아웃",
  auth_login_tab: "로그인", auth_signup_tab: "회원가입", auth_name: "이름", auth_sid: "교번/학번",
  auth_email: "이메일", auth_dept: "학과", auth_level: "소속 구분", auth_ug: "학부생", auth_g: "대학원생", auth_faculty: "교원", auth_staff: "직원", auth_portal: "멤버 포털",
  auth_pw: "비밀번호", auth_create: "계정 만들기 & 로그인", auth_creating: "계정 생성 중…",
  auth_need: "프로젝트 제출에는 계명대 구성원 계정이 필요합니다.",
  auth_submitting_as: "제출자:",
  auth_forgot: "비밀번호를 잊으셨나요?", auth_forgot_title: "비밀번호 재설정",
  auth_forgot_sub: "계정 이메일을 입력하시면 재설정 링크를 보내드립니다.",
  auth_forgot_btn: "재설정 링크 보내기", auth_forgot_sent: "등록된 이메일이라면 재설정 링크가 발송되었습니다.",
  auth_back_login: "로그인으로 돌아가기",
  reset_title: "새 비밀번호 설정", reset_new: "새 비밀번호 (최소 6자)", reset_confirm: "새 비밀번호 확인",
  reset_btn: "비밀번호 변경", reset_done: "비밀번호가 변경되었습니다 — 새 비밀번호로 로그인하세요.",
  reset_mismatch: "비밀번호가 일치하지 않습니다", reset_invalid: "재설정 링크가 유효하지 않거나 만료되었습니다. 새로 요청해 주세요.",
  stat_users: "등록 구성원 수", stat_rating: "평균 평점",
  hero_spot_tag: "실험실 실시간 소식",
  hero_spot_quote: "SignBridge 팀, 글로벌 AI 해커톤 1위 — 214개 대학 참가.",
  hero_spot_link: "프로젝트 보기",
  metric_projects: "AI 프로젝트", metric_depts: "단과대학", metric_patents: "출원 특허", metric_funding: "연구비",
  feat_overline: "주요 캡스톤", feat_title_a: "이번 학기의", feat_title_b: "스포트라이트", feat_view_all: "전체 갤러리",
  mani_overline: "계명 선언문",
  mani_title_a: "여기 있는 모든", mani_title_b: "프로젝트", mani_title_c: "뒤에 있는 네 가지 약속.",
  dept_overline: "단과대학 & 학부", dept_title_a: "모든 작업이", dept_title_b: "시작되는 곳", dept_view_all: "전체 프로젝트 보기",
  dept_showcased: "개 전시", dept_project: "프로젝트", dept_projects: "프로젝트",
  news_overline: "소식 & 행사", news_title_a: "캠퍼스에서", news_title_b: "전해드립니다",
  gallery_overline: "갤러리", gallery_title_a: "AI", gallery_title_b: "프로젝트",
  gallery_subtitle: "아래의 모든 작품은 계명대학교 스튜디오와 연구실에서 교수 검토를 거친 성과입니다.",
  gallery_search: "프로젝트, 아이디어, 기술 검색…", gallery_all_depts: "전체 단과대학", gallery_all: "전체",
  gallery_loading: "갤러리 불러오는 중…", gallery_empty_a: "검색 결과가 없습니다.", gallery_empty_b: "다른 키워드를 입력하거나 직접 프로젝트를 제출해 보세요.",
  sub_title: "프로젝트 제출", sub_subtitle: "공개 갤러리 게시 전 교수 검토가 진행됩니다.",
  sub_step: "단계", sub_of: "/",
  sub_f_title: "프로젝트 제목", sub_f_title_ph: "예: AURA — 자율주행 드론 내비게이션",
  sub_f_tagline: "한 줄 소개", sub_f_tagline_ph: "아이디어를 담은 한 문장",
  sub_f_dept: "소속 단과대학/학과", sub_f_dept_ph: "학과 선택", sub_f_cat: "분야", sub_f_cat_ph: "분야 선택",
  sub_f_other: "기타 (직접 입력)", sub_f_other_ph: "학과 또는 과목을 직접 입력", sub_f_other_cat_ph: "분야 또는 주제를 직접 입력",
  sub_f_desc: "상세 설명", sub_f_desc_ph: "무엇을 하나요? 누구에게 도움이 되나요? 어떤 성과를 측정했나요?",
  sub_f_team: "팀원 (쉼표로 구분)", sub_f_team_ph: "박지훈, 임소연",
  sub_f_emails: "팀 이메일 (선택, 쉼표 구분, 동일 순서)", sub_f_emails_ph: "jihun@kmu.ac.kr, soyeon@kmu.ac.kr",
  sub_f_video: "YouTube 데모 URL (선택)",
  sub_f_tech: "기술 스택 (쉼표로 구분)", sub_f_tech_ph: "PyTorch, ROS 2, React",
  sub_f_demo: "데모 URL (선택)", sub_f_github: "GitHub URL (선택)", sub_f_award: "수상 / 수상 실적 (선택)", sub_f_award_ph: "예: 2026 교내 해커톤 1위", sub_f_image: "프로젝트 이미지",
  sub_f_upload: "커버 이미지 업로드 (PNG / JPG)", sub_f_imgurl_ph: "…또는 이미지 URL 붙여넣기",
  sub_next: "계속", sub_back: "이전", sub_submit: "검토 요청 제출", sub_submitting: "제출 중…",
  sub_closed: "현재 제출이 마감되었습니다", sub_closed_body: "교수진이 신규 제출을 일시 중단했습니다. 잠시 후 다시 확인해 주세요.",
  sub_success: "프로젝트가 교수 검토용으로 제출되었습니다", sub_success_desc: "관리자 승인 후 갤러리에 게시됩니다.",
  login_tag: "계명대학교", login_title: "관리자 포털", login_sub: "교수진 검토 및 분석 접근.",
  login_id_ph: "관리자 ID", login_pw_ph: "비밀번호", login_btn: "로그인", login_busy: "로그인 중…", login_welcome: "환영합니다, 관리자님",
  admin_tag: "교수 콘솔", admin_title: "검토 & 분석", admin_signout: "로그아웃",
  stat_views: "총 조회수", stat_likes: "총 좋아요", stat_approved: "승인됨", stat_pending: "검토 대기",
  chart_title: "단과대학별 조회수 (승인된 프로젝트)",
  tab_pending: "대기", tab_approved: "승인됨", tab_rejected: "반려됨", tab_all: "전체",
  act_approve: "승인", act_reject: "반려", act_feature: "추천", act_featured: "추천됨", act_delete: "삭제",
  feedback_ph: "프로젝트 팀에게 보낼 피드백…", act_confirm: "확인", queue_empty: "이 대기열에 프로젝트가 없습니다.",
  news_mgr: "소식 & 행사 관리", news_new: "새 소식 게시", news_edit: "항목 수정",
  news_f_title: "제목", news_f_excerpt: "요약", news_f_tag: "태그 (행사 / 연구 / …)", news_f_date: "날짜", news_f_img: "이미지 URL",
  news_publish: "게시", news_update: "변경 저장", news_cancel: "취소", news_delete: "삭제", news_edit_btn: "수정", news_empty: "등록된 소식이 없습니다.",
  feat_toggles: "사이트 기능", feat_toggles_sub: "홈페이지 섹션과 공개 기능을 켜거나 끕니다.",
  toggle_news: "소식 & 행사 섹션", toggle_marquee: "에디토리얼 마키", toggle_manifesto: "선언문 챕터",
  toggle_departments: "단과대학 쇼케이스", toggle_submissions: "공개 프로젝트 제출",
  creds_title: "관리자 계정", creds_sub: "로그인 ID와 비밀번호를 변경합니다. 현재 비밀번호가 필요합니다.",
  creds_current: "현재 비밀번호", creds_new_id: "새 관리자 ID (선택)", creds_new_pw: "새 비밀번호 (선택, 최소 8자)",
  creds_save: "계정 정보 변경", creds_saving: "변경 중…",
  footer_tagline: "계명대학교 공식 AI 프로젝트 쇼케이스 — 학생, 교수, 직원의 연구, 창의성, 기술이 교실을 넘어 세상으로 나아가는 곳.",
  footer_platform: "플랫폼", footer_campus: "캠퍼스", footer_gallery: "프로젝트 갤러리", footer_manifesto: "선언문",
  footer_departments: "단과대학", footer_admin: "관리자 포털", footer_rights: "© 2026 계명대학교 · AI 프로젝트 쇼케이스", footer_contact: "문의 사항이 있으신가요?",
  footer_top: "맨 위로",
  views_label: "조회", like_toast: "팀에게 응원을 보냈습니다", like_fail: "좋아요를 등록할 수 없습니다",
  demo_link: "라이브 데모", team_label: "팀", tech_label: "기술 스택", video_label: "데모 영상",
  mkt_search: "프로젝트 검색 (예: 드론, AI, 한복)", mkt_sort_popular: "정렬: 인기순", mkt_sort_latest: "정렬: 최신순",
  mkt_all: "전체", mkt_top: "지금 인기있는 프로젝트", mkt_stats: "쇼케이스 통계",
  stat_total: "등록된 프로젝트", stat_views: "총 조회수", stat_likes: "총 좋아요", stat_depts: "참여 학과",
  mkt_more: "모든 프로젝트 보기", mkt_details: "자세히 보기", mkt_run: "데모", mkt_by: "개발:",
  mkt_login_details: "로그인 후 프로젝트 상세 정보와 데모를 확인하세요", like_login: "로그인 후 좋아요를 누를 수 있습니다",
  val1_t: "구성원이 만듭니다", val1_b: "캡스톤, 부트캠프, 연구실 프로젝트 결과물",
  val2_t: "검증을 거칩니다", val2_b: "모든 프로젝트는 게시 전 교수 검토 통과",
  val3_t: "캠퍼스에 공개합니다", val3_b: "승인된 작품은 모두에게 공개됩니다",
  val4_t: "함께 성장합니다", val4_b: "커뮤니티 피드백이 더 나은 프로젝트를 만듭니다",
  nav_overview: "개요", nav_projects_adm: "프로젝트", nav_trash: "휴지통", nav_news_adm: "소식", nav_features: "기능", nav_creds: "계정",
  trash_empty: "휴지통이 비어 있습니다. 삭제된 프로젝트가 여기에 표시됩니다.",
  act_restore: "복구", act_delete_forever: "영구 삭제", act_sure: "확실합니까?",
  top_title: "조회수 상위 프로젝트", overview_sub: "플랫폼 성과 한눈에 보기",
  adm_submitted_by: "제출자", adm_links: "링크", adm_edit_project: "프로젝트 수정",
  nav_my_projects: "내 프로젝트", my_title: "내 제출 현황",
  my_sub: "제출한 프로젝트의 교수 검토 상태를 확인하세요.",
  my_empty: "아직 제출한 프로젝트가 없습니다.", my_submitted: "제출일",
  my_feedback: "교수 피드백", my_view_gallery: "갤러리에서 보기",
  my_projects_tab: "제출물", my_account_tab: "계정 설정",
  my_withdraw: "제출 철회", my_edits_pending: "수정 사항 검토 대기 중",
  my_edit_staged_note: "게시된 프로젝트는 그대로 유지되며, 수정 사항은 교수 승인 후 반영됩니다.",
  my_edit_resubmit_note: "저장하면 프로젝트가 다시 검토 대기 상태로 제출됩니다.",
  acct_new_pw: "새 비밀번호 (선택, 최소 6자)", acct_updated: "계정 정보가 업데이트되었습니다",
  adm_edits_pending: "수정 대기", adm_pending_edit_title: "제출자가 제안한 수정 사항",
  adm_approve_edit: "변경 승인", adm_discard_edit: "폐기",
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("kmu_lang") || "en");
  const setLang = (l) => {
    localStorage.setItem("kmu_lang", l);
    setLangState(l);
  };
  const t = lang === "ko" ? KO : EN;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
